module.exports = __webpack_public_path__ + "assets/info_black@2x.png";